<app-base-modal
  [title]="'История чата'"
>
  <div class="container">
    @if (telegramChatHistoryParams?.chatStarted) {
      <div class="row">
        <span class="name">Id рекламы:</span>
        <span>{{ telegramChatHistoryParams?.recordCalendarId }}</span>
      </div>
      <div class="row">
        <span class="name">Дата начала:</span>
        <span>{{ getData() }}</span>
      </div>
    } @else {
      <div class="empty">
        Чат не начат
      </div>
    }
  </div>
  <div class="buttons-container">
    <button
      mat-button
      color="warn"
      type="button"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
  </div>
</app-base-modal>
